import { TramRounded } from "@material-ui/icons";
import React, { useState, useEffect } from "react"
import { Button, Spinner, Table } from "react-bootstrap"
export default () => {
  const cutoff = 70;
  const [imageURL, setImageURL] = useState<any>("");
  const [recognitionData, setRecognitionData] = useState<any>(null);
  const [recognitionLoading, setRecognitionLoading] = useState<boolean>(false);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      setImageURL(URL.createObjectURL(img))
    }
  };

  const getBase64Image = async (img) => {
    var canvas = await document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    img.setAttribute('crossOrigin', 'anonymous');
    var ctx = await canvas.getContext("2d");
    await ctx.drawImage(img, 0, 0);
    var dataURL = await canvas.toDataURL("image/png");
    return await dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }

  return (
    <div>
      {
        //<label>URL:</label>
        //<input onChange={(e) => setImageURL(e.target.value)}></input>
      }
      <div style={{ margin: "10px" }}>
        <input type="file" name="myImage" onChange={(e) => onImageChange(e)} />
      </div>
      <div style={{ margin: "10px", textAlign: "center" }}>
        <img id="imageid" src={imageURL} style={{ maxHeight: "500px" }} />
      </div>

      {
        imageURL !== "" &&
        <div style={{ margin: "10px", textAlign: "center" }}>
          <Button disabled={imageURL === "" || recognitionLoading} onClick={async () => {
            setRecognitionLoading(true)

            //there is a problem with canvas so we need to create canvas wait a second and the create again
            await getBase64Image(document.getElementById("imageid"));
            await new Promise((resolve) => setTimeout(resolve, 1000));
            const imgBase64 = await getBase64Image(document.getElementById("imageid"));

            const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/image-recognition-raw", {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                imgBase64
              })
            })
            setRecognitionData((await response.json()))
            setRecognitionLoading(false)
          }}>
            {
              recognitionLoading ? <Spinner animation="border" /> : "Pedir reconhecimento"
            }
          </Button>
        </div>
      }
      {
        !recognitionLoading && recognitionData &&
        <div style={{ margin: "10px" }}>
          <h4>Resultados: </h4>

          <h4 style={{ textAlign: "center" }}>{recognitionData.CL > cutoff ? recognitionData.CN : "Inconclusivo"}</h4>
          <h5 style={{ textAlign: "center" }}>{recognitionData.CL > cutoff ? recognitionData.CL + " % de confiança" : ""}</h5>
          <br />
          <div>
            <h5>
              Detalhes:
            </h5>
            <Table striped bordered hover>
              <thead>
                <tr style={{textAlign: "center"}}>
                  <th>Nome da Espécie</th>
                  <th>Confiança</th>
                </tr>
              </thead> 
              <tbody>
                {recognitionData.allResults.sort((a,b) => b.SpecieConfidence - a.SpecieConfidence).map((result) =>
                  <tr style={{textAlign: "center", fontWeight: result.SpecieConfidence > cutoff ? "bold" : "normal"}}>
                    <td>{result.SpecieName}</td>
                    <td>{result.SpecieConfidence + " %"}</td>
                  </tr>)}
              </tbody>
            </Table>
          </div>
        </div>
      } 
    </div>
  )
}


